<template lang="pug">
  .component-selectize-driver
    selectize(v-if="options",
      :disabled="disabled",
      :selectedValue="selectedValue",
      :options="options",
      value-field="id",
      :maxItems="maxItems" label-field="name",
      :items="items" :searchField="searchableFields",
      :optionTemplate="optionTemplate",
      :renderTemplate="renderTemplate",
      @itemAdded="optionSelected",
      @itemRemoved="optionRemoved",
      placeholder="Operator")
</template>

<script>
import Selectize from '../../../Selectize'
import BaseSelectize from './BaseSelectize'
import KeplerBackofficeSdk from '../../../../../lib/kepler/backoffice'

export default {
  name: 'SelectizeMaintenanceDriver',
  extends: BaseSelectize,
  components: {Selectize},
  data() {

    return {
      searchableFields: ['id', 'name', 'surname', 'username']
    }
  },
  created() {
    KeplerBackofficeSdk.drivers.list(1, -1, {}).maintenance((data) => {
      this.options = data.items
    })
  },
  methods: {
    optionTemplate(item, escape) {
      return `<div><div>D${item.id} - ${item.name} ${item.surname}</div><div><small>Username: ${item.username}</small></div></div>`
    },
    renderTemplate(item, escape) {
      return `<div><div><small>D${item.id}</small></div> <div>${item.name} ${item.surname}</div></div>`
    }
  },
  props: {
    clientDrivers: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    selectedValue: {}
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeMaintenanceDriver.vue?6e568242